import React, { useState } from "react";
import PropTypes from "prop-types";
import { ReactComponent as InfoIcon } from "images/info.svg";

export default function InfoHoverBlock({ montantPrimeCEE, montantMpr, item }) {
  const [isShown, setShown] = useState(false);
  const mprInfo = `est une aide publique dont le montant varie en fonction des revenus et du type de travaux.`;
  const primeCeeInfo = `est versée par les fournisseurs d'énergie, obligés de financer des opérations d'économies d'énergie.`;
  if (!montantMpr && !montantPrimeCEE) {
    return <div></div>;
  } else {
    return (
      <div>
        <div
          className="info-block-container"
          onClick={() => setShown(!isShown)}
          onMouseEnter={() => setShown(true)}
          onMouseLeave={() => setShown(false)}
        >
          <p className={item === "Prime1" ? "p" : "p2"}>
            <span>
              {item === "Prime1" ? "Prime Sorégies" : "MaPrimeRénov'"}
            </span>
            <span className="iconColor2">
              <InfoIcon />
            </span>
          </p>
          {isShown && (
            <div className="info-block">
              <div>
                {item === "Prime1" && (
                  <p>
                    <strong>La prime Sorégies</strong> : {primeCeeInfo}
                  </p>
                )}
                {item === "Prime2" && (
                  <p>
                    <strong>MaPrimeRénov&apos;</strong> : {mprInfo}
                  </p>
                )}
                {item === "CodePromo" && (
                  <p>
                    <strong>Code Promo</strong>
                  </p>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}
InfoHoverBlock.propTypes = {
  montantPrimeCEE: PropTypes.number,
  montantMpr: PropTypes.number,
  item: PropTypes.string,
};
